import React, { Component } from "react";
import { connect } from "react-redux";

import { Wrapper } from "app/NativeComponents/common";

import Body from "./Body";

import { toggleBadgePopup, updateBadge } from "app/NativeActions";

class BadgePopup extends Component {
  componentDidUpdate(prevProps) {
    if (
      this.props.my_badges &&
      prevProps.my_badges &&
      !prevProps.toggle_badge_popup &&
      !this.props.toggle_badge_popup &&
      this.props.user
    ) {
      let badge_notifications = this.props.user.user_settings
        .badge_notifications;
      let not_seen_badge = false;
      let not_seen_badge_item = null;
      for (var i = 0; i < this.props.my_badges.length; i++) {
        if (
          (this.props.my_badges[i].seen_badge == 0 ||
            this.props.my_badges[i].seen_badge == null) &&
          not_seen_badge == false
        ) {
          not_seen_badge = true;
          not_seen_badge_item = this.props.my_badges[i];
        }
      }
      if (
        not_seen_badge &&
        not_seen_badge_item &&
        badge_notifications === true
      ) {
        this.props.toggleBadgePopup(true, not_seen_badge_item);
      }
    }
  }

  render() {
    if (this.props.toggle_badge_popup) {
      return <Body {...this.props} />;
    }
    return <Wrapper />;
  }
}

const mapStateToProps = ({ auth, badges }) => {
  const { token, user } = auth;
  const { badge, toggle_badge_popup, all_badges, my_badges } = badges;
  return {
    all_badges,
    my_badges,
    badge,
    toggle_badge_popup,
    token,
    user
  };
};

export default connect(mapStateToProps, {
  toggleBadgePopup,
  updateBadge
})(BadgePopup);
